<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container" style="width:1140px;max-width:1140px">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Add/Edit New Contact</h5>
					</div>
					<div class="modal-body" v-if="!saveLoader">
						<form v-on:submit.prevent>
							<div class="form-group row">
								<label class="col-md-3">First Name<sup>*</sup></label>
								<div class="col-sm-4">
									<input
										type="text"
										name="firstName"
										v-model="contactData.first_name"
										class="form-control"
										id="firstName"
										:class="{ 'is-invalid': submitted && !contactData.first_name}"
										autocomplete = "off"
									>
									<span
										v-if="submitted && !contactData.first_name "
										class="invalid-feedback"
									>This field is required</span>
								</div>
							</div>

							<div class="form-group row">
								<label class="col-md-3">Last Name</label>
								<div class="col-sm-4">
									<input
										type="text"
										name="lastName"
										v-model="contactData.last_name"
										class="form-control"
										id="lastName"
										autocomplete = "off"
									>
								</div>
							</div>

							<div class="form-group row">
								<label class="col-md-3">Email<sup>*</sup></label>
								<div class="col-sm-4">
									<input
										type="text"
										name="email"
										v-model="contactData.email"
										@focus = "emailUpdate"
										class="form-control"
										id="email"
										:class="{ 'is-invalid': submitted && !contactData.email}"
										autocomplete = "off"
									>
									<span
										v-if="submitted && !contactData.email "
										class="invalid-feedback"
									>This field is required</span>
								</div>
							</div>

							<div class="form-group row">
								<label class="col-md-3">Phone Number<sup>*</sup></label>
								<div class="col-sm-4">
									<input
										type="text"
										name="phNumber"
										v-model="contactData.phone_no"
										maxlength="14"
										@keyup = "formatPhoneNumber"
										class="form-control"
										id="phone_no"
										:class="{ 'is-invalid': submitted && !contactData.phone_no }"
										autocomplete = "off"
									>
									<span
										v-if="submitted && !contactData.phone_no "
										class="invalid-feedback"
									>This field is required</span>
								</div>
							</div>
						</form>
					</div>
					<div
						class="spinner-border"
						v-else
						style="margin:auto;display:block;margin-top:30px;margin-bottom:30px"
					/>

					<span v-if = "showMsg" class = "no-data-style" style = "margin:15px" >Contact with this email already exists. Please provide a different email address</span>

					<div class="modal-footer" style="justify-content:center">
						<button
							type="button"
							class="btn btn-secondary"
							@click="closeModal([], 'reset')"
						>Cancel</button>
						<button
							type="button"
							class="btn btn-primary"
							@click="saveNewContact"
						>Save</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>


<script>
	import Multiselect from "vue-multiselect";
	import moment from "moment";

	export default {
		name: "AddContactModal",
		data() {
			return {
				contactData: {
					first_name: "",
					last_name: "",
					email: "",
					phone_no: "",
					id:null
				},
				saveLoader: false,
				submitted :  false,
				showMsg: false
			};
		},
		components: {

		},
		watch:{
			editObj:{
				immediate: true,
				 handler (val, oldVal) {
				
				if(this.editObj){
					this.contactData.last_name = this.editObj.last_name ;
					this.contactData.email =  this.editObj.email;
					this.contactData.phone_no = this.editObj.phone_no;
					this.contactData.first_name =  this.editObj.first_name;
					this.contactData.id =  this.editObj.id;
				}
			  }
			}
		},
		mounted(){
			this.contactData.first_name = this.addedNewName;
		},
		props: ["addedNewName", "editObj"],
		methods: {
			emailUpdate(){
				this.showMsg = false;
			},
			saveNewContact() {
				this.submitted = true;
				if(!this.contactData.first_name || !this.contactData.email || !this.contactData.phone_no){

					return ;
				}
				else{
					this.submitted = false;
					this.saveLoader = true;
					let vm = this;
					this.$store
						.dispatch("accounts/saveNewContact", this.contactData)
						.then(res => {
							if(res && res.length && typeof res == 'object'){
								if(vm.contactData && vm.contactData.id){
									vm.closeModal(res, 'edit');
								}
								else{
								    vm.closeModal(res, 'add');
								}
							}
							else{
								vm.showMsg = true
							}
							vm.saveLoader = false;

						});
				}

			},
			closeModal(data, type) {
				this.contactData =  {
					first_name: "",
					last_name: "",
					email: "",
					phone_no: "",
					id:null
				}
				this.showMsg = false
				this.$emit("closeAddContactModal", data, type);
			},
			formatPhoneNumber(e){
				let val = e.target.value;
				e.target.value = val
			    .replace(/\D/g, '')
			    .replace(/(\d{1,3})?(\d{1,3})(\d{1,4})?/g, function(txt, f, s, t) {
			      if (t) {
			        return `(${f}) ${s}-${t}`
			      } else if (s) {
			        return `(${f}) ${s}`
			      } else if (f) {
			        return `(${f})`
			      }
			    });

				// if (this.contactData.phone_no.length == 10) {
				// 	 this.contactData.phone_no = this.contactData.phone_no.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
				// }
			}
		}
	};
</script>

<style lang="scss">
</style>
